import { ISearchQueryParams } from "../redux/common/common.types";

export const getSearchQueryV2 = (queryParams: ISearchQueryParams): string => {
  const { page, rowsPerPage, status, value, columns, date, limit } =
    queryParams;
  let query = "";
  if (status && status !== "-1" && status !== undefined && status !== "") {
    query += `status=${status}&`;
  }
  if (columns && columns.length > 0 && value) {
    query += `columns=${columns}&value=${value}&`;
  }
  if (date?.fromDate) {
    query += `from_date=${date?.fromDate}&`;
  }
  if (date?.toDate) {
    query += `to_date=${date?.toDate}&`;
  }
  if (queryParams.advancedFilters && queryParams.advancedFilters.length > 0) {
    query += `advanceFilter=${JSON.stringify(queryParams.advancedFilters)}&`;
  }
  query += `pageNo=${page}&itemPerPage=${rowsPerPage}&pageLimit=${limit}`;
  return query;
};
